<template>
  <div class="promo-disabled">
    <info16
      class="promo-disabled__icon"
      :width="16"
      :height="16"
    />
    <p class="promo-disabled__text">
      Акции на данный товар не распространяются
    </p>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import useAuthorizations from '@/compositions/user/useAuthorizations';

import Info16 from '@/assets/sprite/svg/16/Info_16.svg';

export default defineComponent({
  name: 'PromoDisabled',
  components: { Info16 },
  setup(props, { emit }) {
    const { isAuthorized } = useAuthorizations();

    const handlerOpenAuth = () => {
      emit('openAuth');
    };

    return { isAuthorized, handlerOpenAuth };
  },
});
</script>

<style lang="less">
.promo-disabled {
  display: flex;

  &__icon {
    flex: 0 0 @size-x4;
    fill: @gray;
    margin-top: 2px;
  }

  &__text {
    .small2();

    color: @black;
    margin: 0;
  }

  &__icon + &__text {
    margin-left: @size-x2;
  }
}
</style>
